import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Papa from 'papaparse';
import { showNotification } from 'redux/actions/ui';
import { EmptyDocument } from 'components/CustomSVG';
import { BackdropCircular } from 'components';


const UploadZone = ({
  setFileData,
  setHeadersError,
  isDisabled
  // maxRows //TODO: enable limit after testing
}) => {
  const dispatch = useDispatch();
  const [dragClass, setDragClass] = useState('');
  const [loadingCSV, setLoadingCSV] = useState(false);

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragClass('drag-shadow');
  };

  const handleParseCSV = async (fileData) => {
    try {
      const data = [];
      setHeadersError(false);
      setLoadingCSV(true);
      await Papa.parse(fileData, {
        skipEmptyLines: true,
        step: (results, parser) => {
          parser.pause();
          data.push(results.data);
          parser.resume();
        },
        complete: () => {
          const headers = data.shift();

          // if (data.length > maxRows) {
          //   dispatch(showNotification('error', 'Not allowed length, maximum 100 rows allowed.'));
          //   setHeadersError(true);
          // }

          if (
            headers?.length
            // && data.length <= 100
          ) {
            setFileData(() => ({headers, data, name: fileData.name}));
          }

          setLoadingCSV(false);
        }
      });
    } catch (error) {
      dispatch(showNotification('error', error));
      setLoadingCSV(false);
    }
  };

  const handleUploadFileData = async (event) => {
    event.persist();
    const {files} = event.target;

    if (files?.length && files[0].type === 'text/csv') {
      await handleParseCSV(files[0]);
    } else {
      dispatch(showNotification('error', 'Uploaded file invalid.'));
    }
  };

  const handleUploadFileOnDrop = async (event) => {
    event.preventDefault();
    event.persist();

    const {files} = event.dataTransfer;

    if (files?.length && files[0].type === 'text/csv') {
      await handleParseCSV(files[0]);
    } else {
      dispatch(showNotification('error', 'Uploaded file invalid.'));
    }
  };

  const handleDragStart = () => setDragClass('drag-shadow');
  return (
    <>
      <label htmlFor="upload-cvg-file" className={`${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
        <div
          className={`h-300 w-full mb-6 flex-column justify-center items-center dropzone ${dragClass}`}
          onDragEnter={handleDragStart}
          onDragOver={handleDragOver}
          onDrop={handleUploadFileOnDrop}
        >
          <div>
            <EmptyDocument />
          </div>
          <span className="font-bold text-16 text-muted">Browse or Drag your file here</span>
          <span className="text-13 text-muted">Files supported: CSV</span>
          {/* <span className="text-13 text-muted">Max count of customers: {maxRows - 1}</span> */}
          <input
            className="hidden"
            onChange={handleUploadFileData}
            id="upload-cvg-file"
            type="file"
            accept="text/csv"
            disabled={isDisabled}
          />
        </div>
      </label>
      <BackdropCircular loading={loadingCSV} />
    </>
  );
};

export default React.memo(UploadZone);
